<template>
  <a-form ref="ruleForm" :rules="rules" :model="form" :labelCol="{ span: 4 }">
    <a-form-item label="奖项名称" name="award_name">
      <a-input v-model:value="form.award_name" placeholder="如：一等奖" style="width:300px"></a-input>
      <p class="s_c999">仅做后台查看使用，不在前端扫码展示</p>
    </a-form-item>
    <a-form-item label="奖项数量类型" name="quantity_type">
      <a-radio-group v-model:value="form.quantity_type" :disabled="type=='edit'||odd_list_length>0">
        <a-radio :value="2">按数量</a-radio>
        <a-radio :value="1">按比例</a-radio>
        <a-tooltip placement="right">
          <template #title>
            请注意，第一个奖项的奖项数量类型选择某一个类型后，后面再添加奖项时，只能添加同类型的奖项
          </template>
          <QuestionCircleOutlined class="s_c376" />
        </a-tooltip>
      </a-radio-group>
    </a-form-item>
    <a-form-item label="奖项数量" name="award_num" v-if="form.quantity_type==2">
      <a-input-number v-model:value="form.award_num" :min='1' :max="surplusNum" :precision="0" placeholder="请输入奖项中奖数量" @blur="countNum" style="width:300px"></a-input-number>
      <p>二维码数量共 {{small_code_num}} 个，未分配数量 {{numCountNum}}</p>
    </a-form-item>
    <a-form-item label="奖项比例" name="percent" v-if="form.quantity_type==1">
      <a-input-number  v-model:value="form.percent" placeholder="请输入奖项比例" :min='0.000001' :max="maxPercent" :precision="6" @blur="countNum" style="width:300px"></a-input-number>
      <span class="p-l-10">%，奖项数量 {{percentCountNum}}</span>
      <p>二维码数量共 {{small_code_num}} 个，未分配数量 {{surplusNum}}</p>
    </a-form-item>
    <a-form-item label="奖项内容" require name="content" style="margin-bottom: 0">
      <div>
        <a-row :gutter="16">
          <a-col :span="3">
            <a-checkbox v-model:checked="form.is_bonus" @change="handelchange1">红包 </a-checkbox>
          </a-col>
          <a-col :span="8">
            <a-input v-model:value="form.bonus_content" readonly placeholder="请选择红包" />
          </a-col>
          <a-col :span="4">
            <a-button type="primary" :disabled="!form.is_bonus" @click="showRed = true"> 选择 </a-button>
          </a-col>
        </a-row>
        <p class="s_c999">为避免红包零钱发放失败,请确保红包零钱余额充足</p>
        <a-row :gutter="16">
          <a-col :span="3">
            <a-checkbox v-model:checked="form.is_point">积分 </a-checkbox>
          </a-col>
          <a-col :span="8">
            <a-input v-model:value="form.point_num" :disabled="!form.is_point" placeholder="请输入积分数" />
          </a-col>
        </a-row>
      </div>
    </a-form-item>
  </a-form>
  <a-divider />
  <div class="text-ar">
    <a-button type="primary" ghost class="m-r-15" @click="onClose">取消</a-button>
    <a-button type="primary" @click="onConfirm">确认</a-button>
  </div>
  <a-modal :keyboard="false" title="选择红包" v-model:visible="showRed" centered :width="1200" :footer="null"
    destroyOnClose>
    <selectBouns v-on:select="redSelect" :checkout="false"></selectBouns>
  </a-modal>
</template>
<script>
  import { QuestionCircleOutlined } from "@ant-design/icons-vue";
  import { onMounted,inject, ref, reactive, toRefs, } from "vue";
  import { message } from "ant-design-vue";
  import { iscode } from "@/utils/app";
  import {
    getGuideOddsDetail,
    guideOddsAdd,
    guideOddsEdit,
    guideActivityAwardSurplusCount
  } from "@/api/guide";
  const def = {
    activity_id: "",
    award_name: "",
    quantity_type: 2,
    percent: 0.000001,
    award_num: 1,
    is_point: 0,
    point_num: "",
    is_bonus: 0,
    bonus_id: "",
    bonus_content:"",
  };
  export default {
    components: {QuestionCircleOutlined},
    props: {
      activity_id: {
        type: Number,
        default: () => {
          return null;
        },
      },
      award_id:{
        type:Number
      },
      type:{//概率奖添加/编辑type
        type:String
      },
      quantity_type:{//奖项数量类型，第一个是什么类型，后面的都是什么类型
        type:Number
      },
      odd_list_length:{//概率奖列表长度
        type:Number
      },
    },
    name: "probability",
    setup(props, { emit }) {
      let content = async() =>{
        if (!form.value.is_point&&!form.value.is_bonus) {
          return Promise.reject('请勾选奖项类容');
        } else {
          return Promise.resolve();
        }
      }
      const form = ref({ ...def });
      const state = reactive({
        small_code_num:0,//码范围数量
        maxPercent:100.000000,//按比例，最大比例值
        showRed:false,//是否显示红包
        confirmLoading: false,
        rules: {
          award_name: [{ required: true, message: "请输入奖项名称" }],
          content: [
            { required: true, validator: content}
          ]
        },
        surplusNum:0,//剩余未分配值
        numCountNum:0,//按数量计算的奖项数量
        percentCountNum:0//按比例计算的奖项数量
      });
      const redSelect = (data) => {
        form.value.bonus_id = data.id;
        form.value.bonus_content = data.amount+'元'+data.bonus_type_text;
        state.showRed = false;
      };
      const ruleForm = ref()
      const onConfirm = () =>{
        ruleForm.value.validate().then(async() => {
          let res
          const hide = message.loading('正在加载中...', 0);
          if (props.type=='add') {
            res = await guideOddsAdd({
              ...form.value,
              activity_id:props.activity_id,
              is_bonus: form.value.is_bonus ? 1 : 0,
              is_can_del: form.value.is_can_del ? 1 : 0
            }).then(res => res.data).catch((error) => error);
          } else {
            res = await guideOddsEdit({
              ...form.value,
              award_id:props.award_id,
              activity_id:props.activity_id,
              is_bonus: form.value.is_bonus ? 1 : 0,
              is_point: form.value.is_point ? 1 : 0
            }).then(res => res.data).catch((error) => error);
          }
          if (iscode(res)) {
            setTimeout(hide);
            message.success(res.message);
            emit('oddsubmit')
            ruleForm.value.resetFields();
          } else {
            setTimeout(hide);
            message.error(res.message);
          }
        }).catch(error => {
          message.error('请完善表单！');
        });
      }
      const onClose = () =>{
        emit('oddcolse')
      }
      //概率发奖-详情
      const getOddsDetail = async (e) => {
        let res = await getGuideOddsDetail(props.award_id).then((res) => res.data).catch((error) => error);
        if (iscode(res)) {
          form.value = res.data;
          countNum();
        } else {
          message.error(res.message);
        }
      }
      //概率发奖-剩余数量
      const getSurplusNum = async (e) => {
        let res = await guideActivityAwardSurplusCount({activity_id:props.activity_id,award_id:props.award_id}).then((res) => res.data).catch((error) => error);
        if (iscode(res)) {
          state.surplusNum = res.data.no_set_code_num;
          state.small_code_num = res.data.code_num;
          state.maxPercent = res.data.no_set_code_num/res.data.code_num*100;
          if (props.type=='edit') {
            getOddsDetail();
          }else{
            countNum();
          }
        } else {
          message.error(res.message);
        }
      }
      const countNum = () =>{
        if(form.value.quantity_type==1){
          var num = state.small_code_num*form.value.percent/100;
          var percentCountNum = 0;
          if(num<1){
            percentCountNum = Math.ceil(num)
          }else{
            percentCountNum = Math.floor(num)
          }
          state.percentCountNum = percentCountNum;
        }else{
          state.numCountNum = state.surplusNum-form.value.award_num;
        }
      }
      onMounted(() => {
        form.value.quantity_type = props.quantity_type;
        getSurplusNum();
      });
      return {
        ...toRefs(state),
        form,
        redSelect,
        onConfirm,
        onClose,
        ruleForm,
        countNum
      };
    },
  };
</script>